import React from "react";
import { Menu, Briefcase } from "lucide-react";
import { Button } from "@/components/ui/button";

interface DespachosHeaderProps {
    onOpenSidebar?: () => void;
}

const DespachosHeader = ({ onOpenSidebar }: DespachosHeaderProps) => {
    return (
        <header className="h-11 border-b border-gray-100 bg-white/90 backdrop-blur-md sticky top-0 z-20 flex lg:hidden items-center justify-between px-3 sm:px-6 shrink-0">
            <div className="flex items-center gap-2">
                <Button
                    variant="ghost"
                    size="icon"
                    className="rounded-xl h-8 w-8 text-slate-600 hover:bg-gray-100"
                    onClick={onOpenSidebar}
                    aria-label="Abrir men� de despachos"
                >
                    <Menu className="h-5 w-5" />
                </Button>
                <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-700">
                    <Briefcase className="h-4 w-4 text-legal-blue" />
                    <span>Men� Despachos</span>
                </div>
            </div>
        </header>
    );
};

export default DespachosHeader;
